import React, { forwardRef, useImperativeHandle, useState } from 'react';
import TimezoneSelect from 'react-timezone-select';
import { DatePicker, TimePicker } from 'react-materialize';
import moment from 'moment';

const SelectDate = forwardRef(({ withTimezone = false }, ref) => {
  const [selectedTimezone, setSelectedTimezone] = useState({});
  const [hour, setHour] = useState(0);
  const [date, setDate] = useState(new Date());

  const getFullDate = () => {
    return {
      date: date,
      hour: hour,
      timezone: selectedTimezone.value,
      offset: selectedTimezone.offset,
    };
  };

  useImperativeHandle(ref, () => ({
    getFullDate: getFullDate,
  }));

  const renderTimezoneSelected = () => {
    if (withTimezone) {
      return (
        <div className="col s6">
          <TimezoneSelect value={selectedTimezone} onChange={setSelectedTimezone} />
        </div>
      );
    }
    return <div />;
  };

  const renderDatePicker = () => {
    return (
      <div className="col">
        <p>Date: {date != null ? moment(date).format('MM-DD-YYYY') : null}</p>
        <DatePicker
          options={{
            defaultDate: date,
          }}
          onChange={(value) => {
            const date = new Date(value);
            setDate(date);
          }}
        />
        <TimePicker
          options={{
            defaultTime: 'now',
          }}
          onChange={(e) => {
            setHour(e);
          }}
        />
      </div>
    );
  };

  return (
    <div>
      <div className="row">
        {renderDatePicker()}
        {renderTimezoneSelected()}
      </div>
    </div>
  );
});

export default SelectDate;
